import { LogbookState } from "./slice";
import { LogbookFlight } from "./types";

const initialLogbookFlight: LogbookFlight = {
  filenames: [],
  logHandle: null,
  previewVideoFilename: null,
};

export const getLogbookFlight = (state: LogbookState, flightId: string) =>
  state.flights[flightId] ?? initialLogbookFlight;

export const getLogHandle = (state: LogbookState, flightId: string) =>
  getLogbookFlight(state, flightId).logHandle;

export const isIngestLogRequestActive = (state: LogbookState, flightId: string) =>
  state.requests.ingestLog[flightId]?.active;

export const isRestoreLogRequestActive = (state: LogbookState, flightId: string) =>
  state.requests.restoreLog[flightId]?.active;
